import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { storeName as layoutModelStore } from '../redux/models/layout.model';
import { storeName as projectModelStore } from '../redux/models/project.model';
import { storeName as sitePlanModelStore } from '../redux/models/sitePlan.model';
import { QuestionType } from '../types';
import { getQuestionsByProjectKey } from '../services/questions.service';
import {
  AI_QUESTION_TAGS,
  CONTENT_KEY,
  PROJECT_ITEM_TYPE,
  QUESTION_TYPE,
} from '../commons/constants';
import { getProject } from '../redux/selectors/project.selector';

declare global {
  interface Window {
    setSuggestQuestion: (questions: QuestionType[]) => void;
  }
}

const useAIQuestion = (): void => {
  const locale = useSelector((state) => state[layoutModelStore].locale);
  const contentActiveKey = useSelector((state) => state[projectModelStore].contentActiveKey);
  const projectItemType = useSelector((state) => state[sitePlanModelStore].projectItemType);
  const project = useSelector(getProject);
  const scriptLoaded = useSelector((state) => state[layoutModelStore].chatScriptLoaded);

  const setAIQuestions = async ({ tags }: { tags: string }) => {
    try {
      const res: QuestionType[] = await getQuestionsByProjectKey({
        key: project?.code,
        type: QUESTION_TYPE.AI_QUESTION,
        tags,
        language: locale?.apiLanguage,
      });

      if (window.setSuggestQuestion && res && res.length) {
        window.setSuggestQuestion(res);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!project || !project?.hasAIQuestion || !scriptLoaded || !contentActiveKey) return;
    let tags: string;
    switch (contentActiveKey) {
      case CONTENT_KEY.SITEPLAN.key:
        tags = AI_QUESTION_TAGS.SITEPLAN;

        if (
          projectItemType &&
          (projectItemType === PROJECT_ITEM_TYPE.BUILDING ||
            projectItemType === PROJECT_ITEM_TYPE.VILLA_BLOCK)
        ) {
          tags = AI_QUESTION_TAGS.SITEPLAN_DETAIL;
        }
        break;
      case CONTENT_KEY.AMENITIES.key:
        tags = AI_QUESTION_TAGS.AMENITIES;
        break;
      case CONTENT_KEY.HOME_PROFILE.key:
        tags = AI_QUESTION_TAGS.HOME_PROFILE;
        break;
      case CONTENT_KEY.LOCATION.key:
        tags = AI_QUESTION_TAGS.LOCATION;
        break;
      case CONTENT_KEY.ABOUT.key:
        tags = AI_QUESTION_TAGS.ABOUT;
        break;
      default:
        break;
    }

    if (!tags) return;
    setAIQuestions({ tags });
  }, [project, contentActiveKey, projectItemType, scriptLoaded]);
};

export default useAIQuestion;
